/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponseFromDiscriminatorValue, type WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /catalog/domainaddons
 */
export interface DomainaddonsRequestBuilder extends BaseRequestBuilder<DomainaddonsRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<DomainaddonsRequestBuilderGetQueryParameters> | undefined) : Promise<WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<DomainaddonsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface DomainaddonsRequestBuilderGetQueryParameters {
    coupon?: string;
}
/**
 * Uri template for the request builder.
 */
export const DomainaddonsRequestBuilderUriTemplate = "{+baseurl}/catalog/domainaddons{?coupon*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const DomainaddonsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: DomainaddonsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
